import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ILocale, ITheme, UserModel} from './user.model';
import {ReactiveService} from '../reactive-service.abstract';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from "rxjs";


@Injectable()
export class UserApiService extends ReactiveService  {

  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/user';
  private profileUrl = '/profile';
  private localeUrl = '/locale';

  constructor(private http: HttpClient) {
    super();
  }

  setProfileLocale(locale: ILocale) {
    return this.http.put(this.baseUrl + this.profileUrl + this.localeUrl, null, {params: {locale: locale}});
  }

  setProfileTheme(theme: ITheme) {
    return this.http.put(this.baseUrl + this.profileUrl + '/theme', theme);
  }

  create(data: UserModel): Observable<UserModel> {
    return this.http.post(`${this.baseUrl}`, data);
  }

  save(userId: number, data: UserModel): Observable<UserModel> {
    return this.http.put(`${this.baseUrl}/${userId}`, data);
  }

  getUser(userId: number): Observable<UserModel> {
    return this.http.get(`${this.baseUrl}/${userId}`);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserModel> | Promise<UserModel> | UserModel {
    return this.getUser(route.params.userId);
  }

}
